import { joinPath } from './common.js';
import createEndpointClient from './createEndpointClient.js';
import ClientInstance from './instance.js';
export { ClientError } from './errors.js';
const createRouterClient = (basePath, routerMetadata, instance) => {
    const routerPath = joinPath(basePath, routerMetadata.path);
    return routerMetadata.children.reduce((acc, routerOrEndpointMetadata) => ({
        ...acc,
        [routerOrEndpointMetadata.name]: routerOrEndpointMetadata.type === 'endpoint'
            ? createEndpointClient(routerPath, instance, routerOrEndpointMetadata)
            : createRouterClient(routerPath, routerOrEndpointMetadata, instance),
    }), {});
};
export const generateClientFactory = (metadata) => (baseURL, getRequestSettings, clientOptions = {}) => {
    const instance = new ClientInstance(baseURL, getRequestSettings, clientOptions);
    return createRouterClient('', {
        name: '',
        type: 'router',
        path: '',
        children: metadata,
    }, instance);
};
//# sourceMappingURL=index.js.map